import { render, staticRenderFns } from "./Hotspots360.vue?vue&type=template&id=08624c81&scoped=true"
import script from "./Hotspots360.vue?vue&type=script&lang=js"
export * from "./Hotspots360.vue?vue&type=script&lang=js"
import style0 from "./Hotspots360.vue?vue&type=style&index=0&id=08624c81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08624c81",
  null
  
)

export default component.exports